module.exports = __webpack_public_path__ + "media/images/pc/specials/fair_event/slider/image7-a6b0c6cefb76214832f729be2843af48.jpg";